import { Helmet } from "react-helmet";
import {
  MANNING_RESOURCES,
  MANNING_RESOURCES_TEXT,
  RESOURCE_TEXT_1,
  RESOURCE_TEXT_2,
  RESOURCES,
} from "../../constants/translations";
import PageHeader from "../../hybrids/PageHeader/PageHeader";
import { IoMdCheckmarkCircleOutline, IoMdGlobe } from "react-icons/io";

import mainImage from "../../asset/images/resources/resource-main.png";

const Resources = () => {
  return (
    <>
      <Helmet>
        <title>{RESOURCES}</title>
      </Helmet>
      <div className="resources-page-wrapper">
        <PageHeader
          customClassName="resources-page-header"
          text={MANNING_RESOURCES_TEXT}
          title={MANNING_RESOURCES}
        />
        <section className="resource-main-data">
          <div className="resource-img">
            <img src={mainImage} alt="Resources" width={640} height={720} />
          </div>
          <div className="resource-contents">
            <div className="resource-content dark">
              <div className="content-controller">
                <span className="icon-place">
                  <IoMdGlobe />
                </span>
                <p className="text-place">{RESOURCE_TEXT_1}</p>
              </div>
            </div>
            <div className="resource-content light">
              <div className="content-controller">
                <span className="icon-place">
                  <IoMdCheckmarkCircleOutline />
                </span>
                <p className="text-place">{RESOURCE_TEXT_2}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Resources;
